




























































































































import {
  Vue,
  Component,
  Prop,
  Inject,
  Watch,
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { FamilyMemberRelationship } from "@/shared/types";
import moment from "moment";
import Button from "@/shared/components/ui/Button.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Datepicker from "vuejs-datepicker";
import Input from "@/shared/components/ui/Input.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    Button,
    Checkbox,
    Datepicker,
    Input
  }
})
export default class FamilyMemberComponent extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();

  minimumDateOfBirth = moment().subtract(18, "y");
  isSsnMasked = true;
  showSsnMaskToggle = true;

  @Prop()
  isOwner: boolean;

  @Prop()
  familyMember;

  @Prop()
  index: number;

  @Prop({ required: true })
  identifier: number;

  @Inject() $validator: Validator;

  familyMemberRelationshipOptions = [
    { value: FamilyMemberRelationship.Spouse, text: "Spouse" },
    { value: FamilyMemberRelationship.Child, text: "Child" },
    { value: FamilyMemberRelationship.Other, text: "Other" }
  ];

  @Watch("allowDebitCard")
  allowDebitCardChanged (isNowAllowed) {
    if (!isNowAllowed && this.familyMember.debitCardHolder) {
      this.familyMember.debitCardHolder = false;
    }
  }

  get allowSsnInput (): boolean {
    return this.custodianSettingsStore.allowFamilyMemberSsnInput && this.allowDebitCard &&
        this.familyMember.debitCardHolder;
  }

  removeFamilyMember (): void {
    this.$emit("deleted", this.index);
  }

  get familyMemberInitials (): string {
    const firstInitial = this.familyMember.firstName.charAt(0);
    const secondInitial = this.familyMember.lastName.charAt(0);

    return `${firstInitial}${secondInitial}`;
  }

  get allowDebitCard (): boolean {
    return (this.familyMember.dateOfBirth
        && !this.hasError("Date of birth")
        && this.isOldEnoughForHSACard);
  }

  get isOldEnoughForHSACard (): boolean {
    const dateOfBirthValue = this.familyMember.dateOfBirth;
    if (!dateOfBirthValue) {
      return false;
    }
    const parsedDateOfBirth = moment(dateOfBirthValue);
    return parsedDateOfBirth.isValid() && parsedDateOfBirth.isBefore(this.minimumDateOfBirth);
  }

  get dateValidator () {
    return {
      required: true,
      date_format: "MM/DD/YYYY"
    };
  }

  get scopeId (): string {
    return `${this.identifier}`;
  }

  hasError (name): boolean {
    const scopedId = `${this.identifier}.${name}`;
    return this.$validator.errors.has(scopedId);
  }

  getError (name): string {
    const scopedId = `${this.identifier}.${name}`;
    return this.$validator.errors.first(scopedId);
  }

  get lastFourSsn (): string {
    const ssnLength = this.familyMember.ssn.length;
    if (ssnLength) {
      return `XXX-XX-${this.familyMember.ssn.substring(7, ssnLength)}`;
    }

    return null;
  }

  toggleSsnMask (): void {
    this.isSsnMasked = !this.isSsnMasked;
  }

  toggleDebitCardCheckbox (): void {
    if (!this.familyMember.ssn) {
      this.isSsnMasked = false;
      this.showSsnMaskToggle = false;
    }

    this.familyMember.debitCardHolder = !this.familyMember.debitCardHolder;
  }
}
